import { ApplicationStatusType } from '@apply/constants';
import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';
import { Applications } from './components/Applications/Applications';
import { Incomplete } from './components/Incomplete/Incomplete';
import { mockApplicationsGridData } from './components/mockData/mockApplicationsGridData'; //Replace with api call in future card

export const BridgeApplications = () => {
    const incompleteApps = mockApplicationsGridData.filter((x) => x.applicationStatusTypeId === ApplicationStatusType.Incomplete);

    const submittedApps = mockApplicationsGridData.filter(
        (x) =>
            x.applicationStatusTypeId === ApplicationStatusType.SubmittedByApplicant ||
            x.applicationStatusTypeId === ApplicationStatusType.SubmittedForReview ||
            x.applicationStatusTypeId === ApplicationStatusType.Appraise
    );
    return (
        <>
            <SectionHeaderBar title={'Apps'}></SectionHeaderBar>
            <div
                className='main-content'
                style={{ padding: 0 }}
            >
                <div className='scrollable-content-without-search'>
                    <Incomplete data={incompleteApps} />
                    <Applications data={submittedApps} />
                    <div style={{ paddingTop: '20px' }}>**This screen is bound to mock data for demo purposes.</div>
                </div>
            </div>
        </>
    );
};
